import { Box, IconButton, Typography } from "@mui/material";
import { MdArrowBack } from "react-icons/md";

export default function TeamPricingHeader({
  showBackButton,
  onBack,
  planName,
}) {
  return (
    <Box className="mb-6">
      <Box className="flex items-center gap-2">
        {showBackButton && (
          <IconButton
            size="small"
            onClick={onBack}
            aria-label="Go back"
            sx={{ color: "#0F172A" }}
          >
            <MdArrowBack />
          </IconButton>
        )}
        <Typography variant="h5" className="font-bold text-slate-900">
          Team Pricing Configuration
        </Typography>
      </Box>
      <Typography variant="body2" className="text-slate-600 mt-1">
        {planName ? `Editing ${planName}` : ""}
      </Typography>
    </Box>
  );
}
